module.exports = __webpack_public_path__ + "img/china_broadnet.309fd803.png";